import { forwardRef } from 'react';
import { StyledKeybind } from './styled';

const Keybind = forwardRef((props, ref) => (
  <StyledKeybind ref={ref} {...props} />
));

export default Keybind;
